import { Checkbox } from "@/components/ui/checkbox";

import { FeedbackCategoryIcon } from "./FeedbackCategoryIcon";
import {
  FEEDBACK_CATEGORIES,
  type FeedbackCategoryId,
} from "./feedbackTaxonomy";

export const FeedbackCategoryFieldset = ({
  selected,
  onChange,
}: {
  selected: readonly FeedbackCategoryId[];
  onChange: (categoryId: FeedbackCategoryId, checked: boolean) => void;
}) => (
  <fieldset className="space-y-2" aria-describedby="feedback-categories-help">
    <legend className="text-sm font-medium">Issue categories (optional)</legend>
    <p id="feedback-categories-help" className="text-xs text-muted-foreground">
      Choose every category that applies. Use Other when none of the named
      categories fit.
    </p>
    <div className="grid gap-2 sm:grid-cols-2">
      {FEEDBACK_CATEGORIES.map((category) => {
        const checkboxId = `echo-feedback-category-${category.id}`;
        return (
          <label
            key={category.id}
            htmlFor={checkboxId}
            className="flex cursor-pointer items-center gap-2 rounded-md border px-3 py-2 text-sm transition hover:bg-muted/50"
          >
            <Checkbox
              id={checkboxId}
              checked={selected.includes(category.id)}
              onCheckedChange={(checked) =>
                onChange(category.id, checked === true)
              }
            />
            <FeedbackCategoryIcon iconKey={category.iconKey} />
            <span>{category.label}</span>
          </label>
        );
      })}
    </div>
  </fieldset>
);
